let backendHost;
const apiVersion1 = "v1";
const apiVersion2 = "v2";

const hostname = window && window.location && window.location.hostname;

if (hostname === "shopifyapptest2.herokuapp.com") {
  backendHost = "https://shopifyapptest2.herokuapp.com/";
} else if (hostname === "shopifyapptest1.herokuapp.com") {
  backendHost = "https://shopifyapptest1.herokuapp.com/";
} else if (hostname === "mile1.ca") {
  backendHost = "https://mile1.ca/";
} else if (hostname === "mile1delivery.herokuapp.com") {
  backendHost = "https://mile1delivery.herokuapp.com/";
} else if (hostname === "mile1testing.herokuapp.com") {
  backendHost = "https://mile1testing.herokuapp.com/";
} else if (hostname === "mile1react.herokuapp.com") {
  backendHost = "https://mile1react.herokuapp.com/";
} else if (hostname === "746e009716184b1d9d411c45f6336273.vfs.cloud9.us-east-2.amazonaws.com") {
  backendHost = "https://746e009716184b1d9d411c45f6336273.vfs.cloud9.us-east-2.amazonaws.com/";
} else {
  backendHost = process.env.REACT_APP_BACKEND_HOST || "http://localhost:3000/";
}

export const API_HOST = backendHost;
export const API_ROOT = `${backendHost}api/${apiVersion2}`;
export const API_ROOT1 = `${backendHost}api/${apiVersion1}`;
